module.exports = __webpack_public_path__ + "img/logo.8f642bcf.png";